module.exports = __webpack_public_path__ + "static/How-to-go-from-Wireframe-to-Low-fidelity-Prototype-719ef7407a860cb67a1c57866e4926a7.png";